import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BuildingsComponent } from './buildings/buildings/buildings.component';
import { BuildingSheetComponent } from './buildings/building-sheet/building-sheet.component';
import { QuestionnaryComponent } from './audit/questionnary/questionnary.component';

import { ReportComponent } from './audit/report/report.component';
import { SynthesisComponent } from './synthesis/synthesis/synthesis.component';
import { IntroComponent } from './appcomponents/intro/intro.component';
import { FeedComponent } from './incidents/feed/feed.component';
import { ListComponent } from './incidents/list/list.component';
import { StatsComponent } from './statistics/stats/stats.component';
import { BuildingFormComponent } from './buildings/building-form/building-form.component';
import { IncidentFormComponent } from './incidents/form/form.component';
import { RMMainComponent } from './risk-management/rmmain/rmmain.component';
import { AuditGeneratorComponent } from './risk-management/audit-generator/audit-generator.component';
import { ObjectifComponent } from './risk-management/objectif/objectif.component';
import { IncidentSheetComponent } from './incidents/incident-sheet/incident-sheet.component';


const routes: Routes = [
  { path: '', component: IntroComponent },
  { path: 'buildings', component: BuildingsComponent },
  { path: 'buildings/new', component: BuildingFormComponent },
  { path: 'buildings/edit/:building', component: BuildingFormComponent },
  { path: 'buildings/:building', component: BuildingSheetComponent },
  // { path: 'diagnostic/new/:building/:buildingType/:questionnary', component: DiagnosticComponent },
  // { path: 'diagnostic/edit/:diagnostic', component: DiagnosticComponent },
  { path: 'questionnary/:diagnostic', component: QuestionnaryComponent},
  { path: 'report/:diagnostic', component: ReportComponent },
  { path: 'synthesis', component: SynthesisComponent },
  { path: 'incidents', component: FeedComponent },
  { path: 'incidents/', component: FeedComponent },
  { path: 'incidents/:incident', component: IncidentSheetComponent },
  { path: 'incidents/:building/new', component: IncidentFormComponent },
  { path: 'incidents/edit/:incident', component: IncidentFormComponent },
  { path: 'statistiques', component: StatsComponent },
  { path: 'statistiques/:building', component: StatsComponent },
  { path : 'rm/objectifs', component: RMMainComponent, pathMatch: 'full' },
  //{ path : 'rm/objectifs/:building', component: RMMainComponent },
  { path : 'rm/objectifs/:objectif', component: ObjectifComponent, pathMatch: 'full' },
  { path : 'rm/generator/:diagnostic', component: AuditGeneratorComponent, pathMatch: 'full'}
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
